import { Select, SelectOption } from "@tblabs/truffle";
import { CameraPictureControl } from "./CameraPictureControl";


export class CameraPicturePresetSelector extends Select<string>
{
    constructor(_control: CameraPictureControl)
    {
        const options = _control.Presets.Map(p => new SelectOption(p.Label, p.Name));

        super(_control.CurrentPresetName, options);

        this.Class("quality-selector");
    }
}
